import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Radio, Tooltip } from 'antd';
import { SectionsNodeModel } from '../../models';
import { SubmissionScopes } from '../../misc';
import { ExclamationCircleIcon } from '../../../custom_shared/icons';
import { useAppStore } from '../../stores';
import './SubmissionScopeSelect.less';

interface Props {
    node: SectionsNodeModel;
}

const SubmissionScopeSelect: React.FC<Props> = ({ node }) => {
    const { actionStore } = useAppStore();

    if (!node.submissionScope) {
        return null;
    }

    const tooltipTitle = (
        <>
            <div>
                Please specify if instalment terms cover the entire contract or are defined for each section separately.
            </div>
            <div>For existing contracts, this setting may be locked to its original level.</div>
        </>
    );

    return (
        <div className="submission-scope-select-container">
            <Radio.Group
                className="submission-scope-radio-group"
                value={node.submissionScope}
                onChange={event => {
                    node.setSubmissionScope(event.target.value);
                    actionStore.rebuildNodes();
                }}
            >
                <Radio value={SubmissionScopes.MainSectionOnly}>For the entire contract</Radio>
                <Radio value={SubmissionScopes.SectionLevel}>Per individual section</Radio>
            </Radio.Group>

            <Tooltip
                title={tooltipTitle}
                placement="topLeft"
                overlayStyle={{
                    maxWidth: 800
                }}
            >
                <ExclamationCircleIcon width={20} height={20} color="#717887" />
            </Tooltip>
        </div>
    );
};

export default observer(SubmissionScopeSelect);
